module.exports = __webpack_public_path__ + "static/media/cross-out.c7952fb3.svg";